export function formatPrice(price = 0) {
  return new Intl.NumberFormat().format(parseFloat(price));
}
